import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/ForecastSimple`,
});

export const coreApi = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/forecast`,
});

export const MasterApi = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/Master`,
});
